<crm-tree-select
  [options]="options"
  [(selectedItem)]="selectedTarget"
  (selectedItemChange)="changeSelectedTarget($event)"
  [class]="isError ? ' ng-invalid ng-dirty' : ''"
  [label]="isFloatLabel ? 'Реквизит' : ''"
  [appendTo]="appendTo"
  [showClear]="showClear"
  display="comma"
  dataKey="target"
  optionLabel="label"
  sort="label:string">
  <ng-template
    #valueTemplate
    let-node="node">
    {{ node?.data?.path }}
  </ng-template>
</crm-tree-select>
